import React from 'react';
import './PersonalInfoSection.scss';
import {getQueryElement} from '../../../../utils/queryElement';
import Input from '../../../../components/Input/Input';
import {updateDateOfBirth, updateEmail, updatePIFirstName, updatePILastName} from '../../../../redux/app-state-slice';
import {ToolTip} from '../../../../components/ToolTip/ToolTip';
import FOMOInfoIcon from '../../../../assets/icons/info-circle-filled-white.svg';
import {DATA_FIELDS_ID} from '../../constants';

const {DOB, FIRST_NAME, LAST_NAME, EMAIL} = DATA_FIELDS_ID;
export function focusOnDOBInput(e, elementId, customerData) {
  if (e.target.value.length === 2) {
    getQueryElement(customerData).getElementById(elementId).focus();
  }
}

function PersonalInfoSection({dispatch, customerData}) {
  return (
    <div id='prequal--web--personal-info-section'>
      <div className='prequal--web--bootstrap-styles'>
        <div className='prequal--wc--input-tooltip-container'>
          <div className='prequal--web--name-input-section prequal--wc--name-input-section'>
            <div className='prequal--web--input-container prequal--wc--input-container'>
              <div className='form-floating'>
                <Input
                  type='text'
                  id={FIRST_NAME}
                  maxLength='15'
                  onInputChangeHandler={(e) => dispatch(updatePIFirstName(e.target.value))}
                  onBlurChangeHandler={(e) => {
                    if (customerData.firstName.value > 0) {
                      dispatch(updatePIFirstName(e.target.value.trim()));
                    }
                  }}
                  name={FIRST_NAME}
                  dataTestId={FIRST_NAME}
                  value={customerData.firstName.value}
                  placeholder='First Name'
                  autoComplete='given-name'
                  inputHasError={customerData.firstName.errorMessage}
                />
                <label className='prequal--wc--prequal-form-label prequal--web--prequal-form-label-dark' htmlFor='firstName'>
                  First Name
                </label>
                {customerData.firstName.errorMessage && (
                  <p id='firstname-error-message' className='prequal--web--fomo-error-message'>
                    {customerData.firstName.errorMessage}
                  </p>
                )}
              </div>
            </div>
            <div className='prequal--web--input-container prequal--wc--input-container'>
              <div className='prequal--wc--input-tooltip-container'>
                <div className='form-floating prequal--wc--last-name-input-container'>
                  <Input
                    type='text'
                    id={LAST_NAME}
                    maxLength='40'
                    onInputChangeHandler={(e) => dispatch(updatePILastName(e.target.value))}
                    onBlurChangeHandler={(e) => dispatch(updatePILastName(e.target.value.trim()))}
                    name={LAST_NAME}
                    dataTestId={LAST_NAME}
                    value={customerData.lastName.value}
                    placeholder='Last Name'
                    autoComplete='family-name'
                    inputHasError={customerData.lastName.errorMessage}
                  />
                  <label className='prequal--wc--prequal-form-label prequal--web--prequal-form-label-dark' htmlFor='lastName'>
                    Last Name
                  </label>
                </div>
              </div>
              {customerData.lastName.errorMessage && (
                <p id='lastname-error-message' className='prequal--web--fomo-error-message'>
                  {customerData.lastName.errorMessage}
                </p>
              )}
            </div>
          </div>
        </div>
        <div className='prequal--web--input-container prequal--wc--input-container'>
          <div className='prequal--wc--input-tooltip-container'>
            <div className='form-floating'>
              <Input
                type='text'
                id={EMAIL}
                maxLength='40'
                onInputChangeHandler={(e) => dispatch(updateEmail(e.target.value))}
                onBlurChangeHandler={(e) => dispatch(updateEmail(e.target.value.trim()))}
                slot='input'
                name={EMAIL}
                dataTestId={EMAIL}
                value={customerData.email.value}
                placeholder='Email'
                autoComplete={EMAIL}
                inputHasError={customerData.email.errorMessage}
              />
              <label className='prequal--wc--prequal-form-label prequal--web--prequal-form-label-dark' htmlFor='email'>
                Email
              </label>
            </div>
            {!customerData.isDealerHostApplication.value && (
              <div className='prequal--wc--input-tooltip-section'>
                <ToolTip
                  content='Your email is required to send you a copy of your prequalification offer.'
                  position='left-start'
                  header='Email Required'
                  tooltipIcon={FOMOInfoIcon}
                />
              </div>
            )}
          </div>
          {customerData.email.errorMessage && (
            <p id='email-error-message' className='prequal--web--fomo-error-message'>
              {customerData.email.errorMessage}
            </p>
          )}
        </div>
        <div className='prequal--web--dob-input-section prequal--wc--dob-input-section'>
          <div className='prequal--web--input-container'>
            <div className='prequal--wc--input-tooltip-container'>
              <div className='form-floating'>
                <Input
                  type='text'
                  id={DOB}
                  maxLength='10'
                  onInputChangeHandler={(e) => dispatch(updateDateOfBirth(e.target.value))}
                  onBlurChangeHandler={(e) => dispatch(updateDateOfBirth(e.target.value.trim()))}
                  slot='input'
                  name={DOB}
                  dataTestId={DOB}
                  value={customerData.dateOfBirth.value}
                  placeholder='Date of Birth MM/DD/YYYY'
                  inputHasError={customerData.dateOfBirth.errorMessage?.value}
                />
                <label className='prequal--wc--prequal-form-label prequal--web--prequal-form-label-dark' htmlFor='email'>
                  Date of Birth MM/DD/YYYY
                </label>
              </div>
            </div>
          </div>
          {customerData.dateOfBirth.errorMessage?.value && (
            <p id='dob-error-message' className='prequal--web--fomo-error-message'>
              {customerData.dateOfBirth.errorMessage.value}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default PersonalInfoSection;
